'use es6';

import ErrorMessage from 'reporting-ui-components/components/shared/ErrorMessage';
import ErrorBoundary from 'dashboard-components/error/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorBoundaryWrapper = ({
  children,
  onError,
  ErrorComponent = ErrorMessage
}) => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: ErrorComponent,
    onError: onError,
    children: children
  });
};
export default ErrorBoundaryWrapper;